import React from 'react';
import { List } from 'immutable';
import PropTypes from 'prop-types';

import { Button } from '@els/els-react--button';
import CurrentAvailableResult from '@Pages/Alerts/AlertsComponents/ResultsFrom/CurrentAvailableResult';

import './AvailableResultsList.scss';

export default function AvailableResultsList(props) {
  const { id, results, wrapperProps, selectResultOfAlert } = props;

  return (
    <ul className="available-results-list">
      {results.map((result) => {
        const runId = result.get('runId');
        const resultDate = <CurrentAvailableResult selectedResultDate={result.get('resultDate')} selectedResultHits={result.get('hits')} />;

        return (
          <li key={runId} className="available-results-list--item">
            <Button
              type="link"
              onClick={() => {
                selectResultOfAlert(id, runId);
                wrapperProps.close();
              }}
              className="e2e-alert-available-date">
              {resultDate}
            </Button>
          </li>
        );
      })}
    </ul>
  );
}

AvailableResultsList.propTypes = {
  id: PropTypes.string.isRequired,
  results: PropTypes.instanceOf(List),
  wrapperProps: PropTypes.shape({
    close: PropTypes.func.isRequired,
  }),
  selectResultOfAlert: PropTypes.func.isRequired,
};
